export default __webpack_public_path__ + "static/media/ps.fbf6d1ff.svg";